import { faTrophy } from '@fortawesome/pro-light-svg-icons/faTrophy'
import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'
import Image from '@space-core/components/image'
import Loader from '@space-core/components/loader'
import useTranslation from '@space-core/hooks/useTranslation'
import { openGamificationEventDispatch } from '@space-events/openGamification'

import EmptyRanking from '@space-shell/assets/images/emptyRanking.svg'

import HotmartCoin from '@space-shell/assets/images/hotmartCoin.svg'
import { BaseNames } from '@space-shell/core/router/constants'

import { useParams } from 'react-router-dom'

import { useRankingUserRequest } from './useRankingUserRequest'

const RankingCard = () => {
  const { t } = useTranslation()
  const { isError, isLoading, data } = useRankingUserRequest()
  const { membership, lang } = useParams()

  const handleRedirectToGamification = () => {
    window.location.pathname = BaseNames.gamificatiton(membership as string, lang as string)
    openGamificationEventDispatch({ arrivedFrom: 'CLUB_PROFILE' })
  }

  const rankingActionProps = {
    role: 'button',
    tabIndex: 0,
    onClick: handleRedirectToGamification,
    onKeyDown: handleRedirectToGamification
  }

  if (isLoading) {
    return <Loader full />
  }

  if (isError) {
    return null
  }

  const isRankingMember = data.points !== 0

  if (!isRankingMember) {
    return (
      <div
        className='_d-flex _flex-row _bg-gray-100 _px-3 _py-4 _rounded-md _cursor-pointer'
        data-test='empty-ranking'
        {...rankingActionProps}>
        <div className='_d-flex _align-items-center _mr-4'>
          <Image src={EmptyRanking} aria-hidden />
        </div>
        <div className='_d-flex _flex-column _text-center'>
          <span className='_text-1'>{t('gamification.ranking_card.empty_state')}</span>
        </div>
      </div>
    )
  }

  return (
    <div className='_d-flex _flex-row _bg-gray-100 _px-3 _py-4 _rounded-md'>
      <div className='_d-flex _align-items-center _mr-4'>
        <Icon icon={faTrophy} className='_text-gray-900 _text-3' />
      </div>
      <div className='_d-flex _flex-column _flex-grow-1'>
        <div className='_d-flex _justify-content-between _font-weight-bold'>
          <span>
            {t('gamification.ranking_card.your_position', {
              number: data.position
            })}
          </span>
          <div className='_d-flex _justify-content-center _align-items-center'>
            <span className='_text-1 _mr-1'>{data.points}</span>
            <Image src={HotmartCoin} aria-hidden />
          </div>
        </div>
        <div className='_d-flex _flex-column'>
          <span className='_text-1'>{t('gamification.ranking_card.ranking_update')}</span>
          <div>
            <Button
              variation='tertiary'
              size='sm'
              onClick={handleRedirectToGamification}
              className='_text-blue _text-1 _font-weight _p-0'>
              {t('gamification.ranking_card.show_ranking')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RankingCard
